import { ClientContractCreation } from 'types';
import { ItemClientContract } from './types';

export const formatClientContractsForPut = (
  clientContracts: ItemClientContract[],
  sortingCenterId: string,
  buyerIdApiPlatform: string,
  clientIdApiPlatform: string,
  isActive: boolean,
): ClientContractCreation[] => {
  return clientContracts.map(clientContract => {
    return {
      buyer: buyerIdApiPlatform,
      material: clientContract.material?.['@id'] ?? '',
      sortingCenter: sortingCenterId,
      client: clientIdApiPlatform,
      isActive,
    };
  });
};
